import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from "axios";
import myplugin from "./domain";
import { Swipe, SwipeItem } from "vant";
import {Lazyload,Dialog,Loading,Image} from 'vant';

Vue.prototype.$axios = axios;
Vue.use(Swipe).use(SwipeItem);
Vue.use(Dialog);
Vue.use(myplugin);
Vue.use(Lazyload);
Vue.use(Loading);
Vue.use(Image);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
